import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

// Single-track ("Product Vault") purchase via Shopify. Button only renders when the backend says it's enabled.
export function useProductVaultCheckout(slug) {
  const [pvEnabled, setPvEnabled] = useState(false);
  const [buying, setBuying] = useState(false);

  useEffect(() => {
    api.get("/public/commerce-config").then(({ data }) => {
      const tracks = data.product_vault_tracks || [];
      setPvEnabled(Boolean(data.product_vault_enabled) && (tracks.length === 0 || tracks.includes(slug)));
    }).catch(() => {});
  }, [slug]);

  const buyTrack = async (source = "track_page") => {
    if (!slug) return;
    setBuying(true);
    try {
      const { data } = await api.post("/billing/create-checkout-session", {
        origin_url: window.location.origin,
        plan: `track:${slug}`,
        utm_source: typeof source === "string" ? source : "track_page",
        consent_no_refund: true,
        consent_timestamp: new Date().toISOString(),
      });
      window.location.href = data.url;
    } catch (e) {
      setBuying(false);
      if (e.response?.status === 401) { window.location.href = `/initiate?next=${encodeURIComponent(window.location.pathname)}`; return; }
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not start checkout");
    }
  };

  return { pvEnabled, buying, buyTrack };
}
